module.exports = __webpack_public_path__ + "static/media/img_wear-remove-03.1f1bd48b.svg";